import { Component, OnInit, inject } from '@angular/core';
import {VersionWatcherService} from "./version-watcher.service";

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit
{
    private versionWatcher = inject(VersionWatcherService);

    ngOnInit(): void
    {
        this.versionWatcher.start();
    }
}
